import {Injectable} from '@angular/core';
import {BehaviorSubject, Subject} from 'rxjs';
import {User} from '../models/users';


@Injectable({
  providedIn: 'root',
})
export class SharedDataService {
  private userSource = new BehaviorSubject<User | null>(this.loadUserFromStorage());
  currentUser$ = this.userSource.asObservable();

  // Events for login/logout actions
  private loginEventSubject = new Subject<User>();
  private logoutEventSubject = new Subject<void>();
  private updateStateEventSubject = new Subject<User>();

  // Observables for components to subscribe to specific events
  public onUserLogin$ = this.loginEventSubject.asObservable();
  public onUserLogout$ = this.logoutEventSubject.asObservable();
  public onUserUpdateState$ = this.updateStateEventSubject.asObservable();

  private readonly USER_KEY = 'logged_in_agent'; // Key for localStorage

  setAgent(user: User): void {
    localStorage.setItem(this.USER_KEY, JSON.stringify(user));
    this.userSource.next(user);

    // Emit login event for components that need to react to user login
    console.log('✅ SharedDataService: Usuario logueado, emitiendo evento de login');
    this.loginEventSubject.next(user);
  }

  updateAgentState(updatedUser: User): void {
    localStorage.setItem(this.USER_KEY, JSON.stringify(updatedUser));
    this.userSource.next(updatedUser);

    // Emit update event for components that need to react to user state changes
    // console.log('🔄 SharedDataService: Estado de usuario actualizado, emitiendo evento de actualización');
    this.updateStateEventSubject.next(updatedUser);
  }

  getAgent(): User | null {
    return this.loadUserFromStorage();
  }

  private loadUserFromStorage(): User | null {
    const userData = localStorage.getItem(this.USER_KEY);
    return userData ? JSON.parse(userData) : null;
  }

  clearUser(): void {
    localStorage.clear();
    sessionStorage.clear();

    // Reset BehaviorSubject
    this.userSource.next(null);

    // Emit logout event for components that need to react to user logout
    console.log('🔐 SharedDataService: Usuario deslogueado, emitiendo evento de logout');
    this.logoutEventSubject.next();
  }

  /**
   * Check if user is currently logged in
   */
  isUserLoggedIn(): boolean {
    return this.getAgent() !== null;
  }

  /**
   * Get current user ID if logged in
   */
  getCurrentUserId(): string | null {
    const user = this.getAgent();
    return user ? user.id : null;
  }
}
